import { Pipe, PipeTransform } from '@angular/core';

/**
 * Definición en la creación de un Pipe de angular para establcer una transformación
 *
 * *Pipe creation to stablish a transformation*
 *
 * @type {Pipe}
 */
@Pipe({
  name: 'stringFormat',
})

/**
 * Definición de la clase StringFormatPipe para transformar textos en el HTML
 *
 * *StringFormatPipe class definition, to transform texts in HTML*
 *
 * @type {class}
 * @implements {PipeTransform}
 */
export class StringFormatPipe implements PipeTransform {

  /**
   * Función para parametrizar textos
   *
   * *Function to parametrize text*
   *
   * @type {class}
   * @implements {PipeTransform}
   */
  transform(text: string, _arguments: string[]): string {
    return `${text}`.replace(/{(\d+)}/g, (match, number) => {
      return typeof _arguments[number] !== 'undefined'
        ? _arguments[number]
        : match
      ;
    });
  }
}
